import { FC } from "react";
import { useTranslation } from "react-i18next";
import { aggregatedData } from "../../../../constants";
import { DiscountsItem } from "src/store/slices/item/subitems/discounts.types";

type DiscountCardDetailsProps = {
  name?: string;
  items: DiscountsItem[];
};

const DiscountCardDetails: FC<DiscountCardDetailsProps> = ({ name, items }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="text-font-default w-full truncate text-base capitalize">{name}</div>
      <div className="flex items-end justify-between gap-2 md:flex-col md:items-start">
        <div className="flex min-w-0 flex-col">
          <div className="text-font-subtle truncate text-xs leading-tight font-medium">{t("Discounts.redemptionCost")}</div>
          <p className="text-font-default truncate text-base leading-tight whitespace-nowrap">{aggregatedData.points.labelTransform(items, t)}</p>
        </div>
      </div>
    </>
  );
};

export default DiscountCardDetails;
